import { useMemo } from "react";
import axios from "axios";
import { API } from "../lib/config";

// API helper — cookies are sent automatically (axios.defaults.withCredentials)
export const useApi = () => {
  return useMemo(() => ({
    get: (url) => axios.get(`${API}${url}`),
    post: (url, data) => axios.post(`${API}${url}`, data),
    put: (url, data) => axios.put(`${API}${url}`, data),
    delete: (url) => axios.delete(`${API}${url}`),
  }), []);
};
